import { render, staticRenderFns } from "./ReminderEvent.vue?vue&type=template&id=72a3d51c&"
import script from "./ReminderEvent.vue?vue&type=script&lang=js&"
export * from "./ReminderEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports